import { render, staticRenderFns } from "./o_award.vue?vue&type=template&id=3f01919d&scoped=true"
import script from "./o_award.vue?vue&type=script&lang=js"
export * from "./o_award.vue?vue&type=script&lang=js"
import style0 from "./o_award.vue?vue&type=style&index=0&id=3f01919d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f01919d",
  null
  
)

export default component.exports